import styled from "styled-components"


export const NamingConventionsPage = () => {
  return (
    <StyleWrap>
      NamingConventions
    </StyleWrap>
  )
}

const StyleWrap = styled.div`

`;